import { nanoid } from "nanoid"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { api, baseURL, superAdminReqConfig } from "../../include/api"
import Error from "../add-ons/Error"
import Spinner from "../add-ons/Spinner"
import SuperAdminHeader from "./Header"

const SuperAdminServiceCategory = () => {
    const [fetchLoading, setFetchLoading] = useState(true)
    const [serviceCategoryList, setServiceCategoryList] = useState([])
    const [searchQuery, setSearchQuery] = useState("")

    useEffect(() => {
        getServiceCategory()
    }, [])

    const getServiceCategory = (afterGet) => {
        setFetchLoading(true)
        api.get("/service_category/", superAdminReqConfig()).then(response => {
            if (response.status === 200) {
                setServiceCategoryList(response.data.data)
                if (afterGet) afterGet(response.data.data)
            }
        }).catch(error => {
            setServiceCategoryList([])
            if (afterGet) afterGet([])
        }).finally(() => setFetchLoading(false))
    }

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value)
    }

    const filteredServiceCategories = serviceCategoryList.filter(serviceCategory =>
        serviceCategory.serviceCatName.toLowerCase().includes(searchQuery.toLowerCase())
    )

    return (
        <SuperAdminHeader>
            <div className="fixed-top-bar">
                <div className="container mt-2 mb-5">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                        <h5 className="m-0">Service Category</h5>
                        
                        <Link to="/super/add-service-category" className="btn btn-success">Add new service category</Link>
                    </div>
                    <div className="py-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search service categories..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />        
                    </div>
                    <span className="small">Total of {filteredServiceCategories.length} Categories</span>

                    {fetchLoading ? (
                        <Spinner color="danger" spinnerSize="lg" />
                    ) : filteredServiceCategories.length > 0 ? (
                        <table className="table table-striped" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredServiceCategories.map((serviceCategory) => (
                                    <ServiceCategory serviceCategory={serviceCategory} key={nanoid()} />
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <Error mainText="No category found!" secondaryText={<Link to="/super/add-category">Add New Service category</Link>} />
                    )}
                </div>
            </div>
        </SuperAdminHeader>
    )
}

const ServiceCategory = ({ serviceCategory }) => {
    return (
        <tr>
            <td style={{ width: "25%" }}>
                <img src={baseURL + "/" + serviceCategory?.imageUrl} alt="" className="fit-contain" style={{ width: "150px", height: "100px" }} />
            </td>
            <td style={{ width: "25%" }}>{serviceCategory.serviceCatName}</td>
            <td style={{ width: "25%" }}>{serviceCategory.description}</td>
            <td style={{ width: "25%" }}>
                <Link to={`/super/edit-service-category/${serviceCategory.id}`} className="btn btn-sm btn-primary mb-3">
                    EDIT
                </Link><br/>
                <button className="btn btn-sm btn-danger text-align-center">
                    DELETE
                </button>
            </td>
        </tr>
    )
}

export default SuperAdminServiceCategory